import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { StyledPreloaderWrapper, StyledLoaderRow, StyledLoaderBtnRow } from "./styles";

export const ManagementSectionPreloader = () => {
    return (
        <StyledPreloaderWrapper>
            <StyledLoaderRow>
                <PixelPlaceholderLoader
                    width={400}
                    height={14}
                />
            </StyledLoaderRow>
            <StyledLoaderRow>
                <PixelPlaceholderLoader
                    width={100}
                    height={12}
                />
                <PixelPlaceholderLoader
                    width={75}
                    height={12}
                />
            </StyledLoaderRow>
            <StyledLoaderRow>
                <PixelPlaceholderLoader
                    width={300}
                    height={12}
                />
            </StyledLoaderRow>
            <StyledLoaderBtnRow>
                <PixelPlaceholderLoader
                    width={150}
                    height={30}
                />
            </StyledLoaderBtnRow>
        </StyledPreloaderWrapper>
    );
};
